/* src/app/location-users/remove-user-modal/remove-user-modal.component.scss */
.modal-header {
  border-bottom: none;
}
.modal-footer {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  border-top: none;
}
p {
  line-height: 13px;
}
textarea {
  resize: none;
  width: 100%;
  border-radius: 0;
  min-height: 70px;
}
.remove-user-modal {
  padding: 10px;
  max-width: 900px;
  width: 100%;
}
.btn-green {
  color: white;
  background-color: #00857D;
  border-radius: 35px;
  width: 97px;
  height: 36px;
}
.btn-white {
  color: #00857D;
  background-color: white;
  border-radius: 35px;
  border: thin #00857D solid;
  width: 97px;
  height: 36px;
  margin-left: 5px;
}
.error {
  color: red;
}
.t-error::placeholder {
  color: red;
  font-size: 1.5em;
  text-align: right;
  font-weight: bold;
}
.t-error {
  border-color: red;
}
/*# sourceMappingURL=remove-user-modal.component.css.map */
